import React, { memo } from 'react';

interface BuildingIconProps {
  size?: number;
}

const BuildingIcon: React.FC<BuildingIconProps> = memo(({ size = 12 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 12 13"
    fill="none">
    <path
      d="M0 11.9V1.10004H6V3.50004H12V11.9H0ZM1.2 10.7H4.8V9.50004H1.2V10.7ZM1.2 8.30004H4.8V7.10004H1.2V8.30004ZM1.2 5.90004H4.8V4.70004H1.2V5.90004ZM1.2 3.50004H4.8V2.30004H1.2V3.50004ZM6 10.7H10.8V4.70004H6V10.7ZM7.2 7.10004V5.90004H9.6V7.10004H7.2ZM7.2 9.50004V8.30004H9.6V9.50004H7.2Z"
      fill="currentColor"
    />
  </svg>
));

export { BuildingIcon };
